<div class="content-wrapper">
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Create New Cost Center</h4>
          <form class="forms-sample" #ngNewCostCenterForm="ngForm" name="form"
            (ngSubmit)="ngNewCostCenterForm.form.valid && onSubmit()" novalidate>

            <!-- Name -->
            <div class="form-group">
              <label for="name">Cost Center Name</label>
              <input type="text" class="form-control" id="name" placeholder="ex: Ewekoro" name="name"
                [(ngModel)]="name" required>
            </div>

            <!-- Description  -->
            <div class="form-group">
              <label for="description">Description</label>
              <input type="text" class="form-control" id="description"
                placeholder="Short description of cost center " name="description" [(ngModel)]="description"
                required>
            </div>

            <!-- Code  -->
            <div class="form-group">
              <label for="description">Code</label>
              <input type="text" class="form-control" id="code"
                placeholder="Cost center code " name="code" [(ngModel)]="code"
                required>
            </div>

            <button type="submit" class="btn btn-primary mr-2">Submit</button>
            <button class="btn btn-light">Cancel</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>